
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardComponent from './projectinvestmentwizard.component';
import './projectinvestmentwizard.scss';

import ProjectInvestmentWizardStep1PageModule from './step1/projectinvestmentwizard.step1.module';
import ProjectInvestmentWizardStep2PageModule from './step2/projectinvestmentwizard.step2.module';
import ProjectInvestmentWizardStep3PageModule from './step3/projectinvestmentwizard.step3.module';

const ProjectInvestmentWizardPageModule = angular.module('project-investment-wizard-module', [
    'ui.router',

    // Child states
    ProjectInvestmentWizardStep1PageModule.name,        // Start (step 1)
    ProjectInvestmentWizardStep2PageModule.name,        // Investor info (step 2)
    ProjectInvestmentWizardStep3PageModule.name,        // Investor agreement (step 3)

  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('projectinvestmentwizard', {
        url: '/project/{id}/new-investment',
        component: 'projectInvestmentWizard',
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          project: function (Projects, $transition$) {
            return Projects.get($transition$.params('to').id, {
              include: ['disclosure_doc']
            });
          },
          profile: function(Profiles) {
            return Profiles.fetchOwn();
          }
        }
      });
  })
  .component('projectInvestmentWizard', new ProjectInvestmentWizardComponent());

export default ProjectInvestmentWizardPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/projectinvestmentwizard.module.js